import {
  FAILED_GET_CUSTOMER,
  FAILED_PERSIST_CUSTOMER,
  RECEIVE_GET_CUSTOMER,
  RECEIVE_GET_CUSTOMERS,
  RECEIVE_PERSIST_CUSTOMER,
  REQUEST_PERSIST_CUSTOMER,
} from 'common/redux/actions/customer'
import { RESET_STATE } from 'common/redux/actions/global'

const initialState = {
  form: {
    data: {},
    error: '',
    fetching: true,
    sending: false,
    deleting: false,
  },
  overview: {
    data: [],
    error: '',
    fetching: true,
    pageNumber: 1,
    totalCount: 0,
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FAILED_GET_CUSTOMER:
    case FAILED_PERSIST_CUSTOMER:
      return {
        ...state,
        form: {
          ...state.form,
          fetching: false,
          sending: false,
          deleting: false,
        },
      }
    case RECEIVE_PERSIST_CUSTOMER:
    case RECEIVE_GET_CUSTOMER:
      return {
        ...state,
        form: {
          data: action.data,
          fetching: false,
          sending: false,
        },
      }
    case RECEIVE_GET_CUSTOMERS:
      return {
        ...state,
        overview: {
          data: action.data,
          fetching: false,
          pageNumber: action.pageNumber,
          totalCount: action.totalCount,
        },
      }
    case REQUEST_PERSIST_CUSTOMER:
      return {
        ...state,
        form: {
          ...state.form,
          sending: true,
        },
      }

    case RESET_STATE:
      if (action.state === 'customer') {
        return {
          ...state,
          [action.screen]: initialState[action.screen],
        }
      }

      return state
    default:
      return state
  }
}
